import React from "react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 md:py-36 bg-[#F3EFE6]/60 paper-grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-x-4 gap-y-10 md:gap-10 lg:gap-20">
          <div className="col-span-12 lg:col-span-4">
            <p className="label-eyebrow">02 · Our Story</p>
            <h2 className="font-serif text-[#1E3A5F] mt-5 text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
              A catering house,
              <br />
              <span className="italic text-[#CBA365]">not a kitchen&nbsp;</span>
              that delivers.
            </h2>
          </div>

          <div className="col-span-12 lg:col-span-7 lg:col-start-6 space-y-6 text-[#1E3A5F]/80 font-light leading-relaxed text-base md:text-[17px]">
            <p data-testid="about-para-1">
              The Office Meal Co. was founded with a simple, stubborn belief:
              corporate food should never taste corporate. Every service we
              run — from a 400-guest award night to a quiet boardroom lunch
              at Embassy TechVillage — begins in a single certified kitchen
              in Electronic City, where our chefs develop menus the way
              couturiers develop collections.
            </p>
            <p data-testid="about-para-2">
              We are not a cloud kitchen. We are not a tiffin service. We are a
              catering house built for companies that choose to serve
              hospitality, not just food.
            </p>

            <div className="grid grid-cols-2 gap-8 pt-8 mt-6 border-t border-[#1E3A5F]/15">
              {[
                { k: "Bespoke Menus", v: "Designed for your team" },
                { k: "In-house Chefs", v: "No third-party kitchens" },
                { k: "Live Stations", v: "On-site execution team" },
                { k: "Diet-first Menus", v: "Jain · Vegan · Keto · Halal" },
              ].map((i) => (
                <div
                  key={i.k}
                  data-testid={`about-highlight-${i.k.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  <div className="font-serif text-[#1E3A5F] text-2xl md:text-3xl">
                    {i.k}
                  </div>
                  <div className="text-xs uppercase tracking-[0.2em] text-[#64748B] mt-2">
                    {i.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
